import { useLanguage } from '../../lib/i18n/LanguageContext';
import { generateAltText, optimizePexelsUrl } from '../../lib/utils/imageOptimization';

const CareersHero = () => {
  const { t } = useLanguage();

  return (
    <div className="relative h-80 flex items-center">
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${optimizePexelsUrl('https://images.pexels.com/photos/5953524/pexels-photo-5953524.jpeg', 1920, 1080)}")`,
          }}
          aria-label={generateAltText('staff', 'Join our team at Rossopomodoro Reykjavik')}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
      </div>
      <div className="container-custom relative z-10 text-center text-white">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
          {t.careers.hero.title}
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto">{t.careers.hero.subtitle}</p>
      </div>
    </div>
  );
};

export default CareersHero;
